/**
 * @file 全应用布局
 * @author zhanglili
 */

import {withClassName} from '@baidu/etui-hocs';
import styles from './index.less';

export default withClassName(styles.root, 'AppLayout')('div');
